"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var yup = __importStar(require("yup"));
exports.PickupLocationValidationSchema = function (t) {
    return yup.object({
        city: yup
            .string()
            .required()
            .max(32)
            .trim(),
        zipCode: yup
            .string()
            .trim()
            .matches(/^(([0-9]{2})-([0-9]{3}))?$/, t ? t('validation:zipCode') : {}),
        streetName: yup
            .string()
            .max(32)
            .trim(),
        buildingNumber: yup.string().max(32),
        status: yup
            .string()
            .required()
            .oneOf(['AVAILABLE', 'UNAVAILABLE']),
        shortName: yup
            .string()
            .trim()
            .max(32),
        priority: yup
            .number()
            .min(0)
            .max(100),
    });
};
//# sourceMappingURL=pickupLocation.js.map